import React, { useEffect, useState, useRef } from "react";
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import { IAM_API_BASE_URL_2 } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { Helmet } from "react-helmet";
import TapIcon from "../../../services/TapIcon";
import { DisplaySearchCriteria, PeriodSelectionWithCustom } from "../../../components/TapUi/index";
import TapSelect from "../../../components/ui/TapSelect";
import { bottom } from "@popperjs/core";
import DateService from "../../../services/DateService";
import moment from "moment";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { Modal } from "bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { toast } from "react-toastify";
import uuid from "react-uuid";


const EscalationDataTrendingReport = (props) => {

    const accessToken                               =   useSelector(state => state.auth.access_token);
    const iam_user_sites                            =   useSelector(state => state.app.user_sites || []);
    const all_period                                =   useSelector(state => state.app.all_periods ? state.app.all_periods: [] );
    const report_listing                            =   useSelector(state => state.app.report_listing ? state.app.report_listing : []);
    const allStatus                                 =   useSelector(state => state.app.status_list || []);
    const trendingEscalationUrl                     =   IAM_API_BASE_URL_2 + '/report/escalation_trending_report';
    const formDataUrl                               =   IAM_API_BASE_URL_2 + '/escalation_formdata';
    const modalId                                   =   uuid();
    const modalElementRef                           =   useRef();
    const modalRef                                  =   useRef();
    const criteriaRef                               =   useRef()
    const [loading, setLoading]                     =   useState(false)
    const [listingData, setListingData]             =   useState([])
    const [userData, setUserData]                   =   useState({})
    const [sites, setSites]                         =   useState([])
    const [formSearchedElems, setFormSearchedElems] =   useState([])
    const [reportSubmitted, setReportSubmitted]     =   useState(false)
    const [iam_group_sites, setIam_group_sites]     =   useState([]);
    const [criteriaHeight, setCriteriaHeight]       =   useState(0)
    const [all_periods, setAll_periods]             =   useState([]);  
    const [ccOptions, setCcOptions]                 =   useState([]);
    const [toOptions, setToOptions]                 =   useState([]);
    const [saveFormSubmitting, setSaveFormSubmitting] = useState(false);
    const [formData, setFormData] = useState(
        {
            loading             :   false,
            data                :   [],
            allTicketType       :   [],
            allStatusList       :   [],

        });
    const [reportName, setReportName]               =   useState({});


    const [submittedReportFilterForm, setSubmittedReportFilterForm] = useState({
        'show'                              : false,
        'search_user'                       : null,
        'search_site_ids'                   : [],
        'date_range'                        : '',
        'date_range_start'                  : null,
        'date_range_end'                    : null,
        'search_ticket_type_ids'             :  [],
        'search_status'                     :   [],

    });
    const [shareEmailForm, setShareEmailForm] = useState({
        to_emails: [],
        subject: 'Trending Escalation Report as on ' + DateService.dateFormat(new Date()),
        message: '',
        include_attachment: 'N'
    });
    const initShareEmail = {
        to_emails: [],
        cc_emails: [],
        subject: 'Trending Escalation Report as on ' + DateService.dateFormat(new Date()),
        message: '',
        include_attachment: 'N'
    };

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height)
            }
        }
    };   

    const reportFilterFormLabel = {
        search_user_id                      : 'Tagged User : ',
        'search_site_ids'                   : 'Site : ',
        'date_range'                        : 'Transaction Period : ',
        'search_ticket_type_ids'             : 'Ticket Type : ',
        'search_status'                     : 'Status : ',
    };

    useEffect(() => {
        loadFormData(props);
    }, [])

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, {
            keyboard: false,
            backdrop: false
        });
        const handleModalHidden = () => {
            handleClose();
        };

        if (modalElementRef.current) {
            modalElementRef.current.addEventListener('hidden.bs.modal', handleModalHidden);
        }

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
            if (modalElementRef.current) {
                modalElementRef.current.removeEventListener('hidden.bs.modal', handleModalHidden);
            }
        };
    }, []);

    const openModal = () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }
    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.hide();
        }
    }
    const shareTicketModalInit = () => {
        if (submittedReportFilterForm.search_user?.email) {
            const matchedEmail = toOptions.find(
                opt => opt.value === submittedReportFilterForm.search_user.email
            );

            if (matchedEmail) {
                setShareEmailForm(prev => ({
                    ...prev,
                    to_emails: [matchedEmail]
                }));
            }
        }
        openModal()
    }
    useEffect(() => {
        updateCriteriaHeight()
        toggleFilterForm(!submittedReportFilterForm.show);
    }, [formSearchedElems]);

    const loadFormData = (props) => {
        const report_name = props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData = report_listing.length > 0 ? report_listing.filter(d => d.key === report_name) : [];

        setReportName(reportData.length > 0 ? reportData[0] : null)

        setFormData(pd => ({ ...pd, loading: true, }))
        let extendedPeriods = [
            ...all_period.filter(period => period.key !== 'today'),
            { key: 'custom', display: 'Custom Date Range' }
        ];
        setIam_group_sites(iam_user_sites.map((s) => ({ value: s.id, label: `${s.site_name} (${s.site_code})` })),)
        HttpAPICall.withAthorization('GET', formDataUrl, accessToken, {}, {}, (resp) => {
            let data = resp.data;
            const emailOpts = data?.level_users.map(user => ({
                value: user.email,
                label: ` ${user.email} (${user.first_name} ${user.last_name}) `,
                id: user.enc_id,
                name: `${user.first_name} ${user.last_name}`
            }));
            setFormData(pd => ({
                ...pd,
                data: data?.level_users.map(d => ({ value: d.enc_id, label: `${d.first_name} ${d.last_name}` , email :d.email})),
                allTicketType : data.ticket_types?.map((s) => {return { value: s.id, label: s.name }}),
                allStatusList: allStatus?.map((s) => {return { value: s.key, label: s.name }}),
            }));
            setCcOptions(emailOpts);
            setToOptions(emailOpts)
            setAll_periods(extendedPeriods);
        }).then(() => {
            setFormData(pd => ({ ...pd, loading: false }));
        })
    }
   
    const closeReport       =   ()  =>  props.history.push({ pathname: `/report` })

    const reportFilterFormSubmit = (event = null) => {
        event && event.preventDefault();

        let searchedElems = [];

        if (submittedReportFilterForm.search_user) {
            const show_val = submittedReportFilterForm.search_user.label;
            searchedElems.push(`${reportFilterFormLabel.search_user_id} <b>${show_val}</b>`);
        }

        if (submittedReportFilterForm.search_site_ids && submittedReportFilterForm.search_site_ids.length > 0) {
            const show_val = iam_group_sites
                .filter((s) => submittedReportFilterForm.search_site_ids.includes(s.value))
                .map(s => s.label)
                .join(', ');
            searchedElems.push(`${reportFilterFormLabel['search_site_ids']} <b>${show_val}</b>`);
        }

        if (submittedReportFilterForm.date_range) {
            let start_range = moment(submittedReportFilterForm.date_range_start).format('DD-MMM-YYYY');
            let end_range = moment(submittedReportFilterForm.date_range_end).format('DD-MMM-YYYY')
            let display_custom = `Custom Date Range (${start_range} - ${end_range})`
            const show_val = all_periods.filter((s) => submittedReportFilterForm?.date_range.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
            searchedElems.push(`${reportFilterFormLabel['date_range']} <b>${show_val}</b>`);

        }
         if (submittedReportFilterForm.search_ticket_type_ids && submittedReportFilterForm.search_ticket_type_ids.length > 0) {
            const show_val = formData?.allTicketType
                .filter((s) => submittedReportFilterForm.search_ticket_type_ids.includes(s.value))
                .map(s => s.label)
                .join(', ');
            searchedElems.push(`${reportFilterFormLabel['search_ticket_type_ids']} <b>${show_val}</b>`);
        }
        
        if (submittedReportFilterForm.search_status && submittedReportFilterForm.search_status.length > 0) {
            const show_val = formData?.allStatusList.filter((s) => submittedReportFilterForm.search_status.includes(s.value)).map((s) => s.label).join(", ");
            searchedElems.push(`${reportFilterFormLabel.search_status} <b>${show_val}</b>`);
        }


        setSubmittedReportFilterForm({ ...submittedReportFilterForm });
        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);
        loadListingTblData(1);
    }

    const submitShareDocument = (event) => {
        event.preventDefault();
        setSaveFormSubmitting(true)
        let frmData = {
            action: "email",
            'search_user_id': submittedReportFilterForm?.search_user.value,
            'search_site_ids': submittedReportFilterForm?.search_site_ids || [],
            to_user_ids: submittedReportFilterForm?.search_user?.value ? [submittedReportFilterForm.search_user.value] : [],
            cc_user_ids: shareEmailForm?.cc_emails?.map(s => s.id),
            subject: shareEmailForm?.subject,
            message: shareEmailForm?.message,
            include_attachment: shareEmailForm?.include_attachment,
            date_range: submittedReportFilterForm.date_range,
            date_range_start: submittedReportFilterForm.date_range_start,
            date_range_end: submittedReportFilterForm.date_range_end,
            search_ticket_type_ids: submittedReportFilterForm?.search_ticket_type_ids || "",
            search_status: submittedReportFilterForm?.search_status || [],
        }
        HttpAPICall.withAthorization('POST', trendingEscalationUrl, accessToken, {}, { ...frmData }, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            handleClose()
            closeModal()
        }).then(() => setSaveFormSubmitting(false))
    };

    const loadListingTblData = (page = 1) => {
        setLoading(true);
        const params = {
            action: "data",
            page: page,
            search_user_id: submittedReportFilterForm.search_user ? submittedReportFilterForm.search_user.value : "",
            search_site_ids: submittedReportFilterForm.search_site_ids,
            date_range: submittedReportFilterForm.date_range,
            date_range_start: submittedReportFilterForm.date_range_start,
            date_range_end: submittedReportFilterForm.date_range_end,
            search_ticket_type_ids: submittedReportFilterForm?.search_ticket_type_ids || "",
            search_status: submittedReportFilterForm?.search_status || [],
        };

        HttpAPICall.withAthorization('GET', trendingEscalationUrl, accessToken, params, {}, (response) => {
            let respData = response.data;
            setListingData(respData || [])
            setUserData({
                user_name: respData.user_name || '',
                sites: respData.sites || [],
                level_name: Array.isArray(respData.levels)
                    ? respData.levels.map(level => level.name).join(', ')
                    : ''
            })
            setSites(respData.sites || [])
        }).then(() => {
            setLoading(false)
        });
    }

    const formInputHandler = (event, formName) => {
        const { name, value, type, checked } = event.target;

        if (formName === 'shareEmailForm') {
            setShareEmailForm(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? (checked ? 'Y' : 'N') : value
            }));
        } else if (formName === 'submittedReportFilterForm') {
            setSubmittedReportFilterForm(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            }));
        }
    };

    const attachmentCheckboxHandler = (e) => {
        setShareEmailForm(prev => ({
            ...prev,
            include_attachment: prev.include_attachment === 'Y' ? 'N' : 'Y'
        }));
    };

    const handleClose = () => {
        setShareEmailForm(initShareEmail);

    }

    const toggleFilterForm = (show) => {
        setSubmittedReportFilterForm(pd => ({ ...pd, show: show }));
        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    }

    const pageTitleBarJsx = () => {

        return (
            <div className="page_title row m0">
                <div className="col-sm-12 px-2">
                    <div className="d-flex align-items-center justify-content-between ">
                        <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faChartLine} /> {reportName?.name}</h3>
                        <div className="d-flex align-items-center ">
                            <button type="button" className="btn btn-secondary" onClick={() => toggleFilterForm(!submittedReportFilterForm.show)} >
                                Change Filter
                            </button>
                            {reportSubmitted &&  <>
                                <button type="button" id='shareTicket' data-bs-toggle="dropdown" aria-expanded="false" className="btn btn-secondary">
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faShareAlt} className="img-fluid" alt="item-action" />
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="shareTicket">
                                    <li><Link className="dropdown-item" role="button" onClick={shareTicketModalInit}>Share by Email</Link></li>
                                </ul>
                            </>}
                            <button type="button" className="btn btn-secondary" onClick={closeReport}>
                                <TapIcon.imageIcon icon={TapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const reportFilterFormJsx = () => {
        return (
            <form onSubmit={reportFilterFormSubmit} className='py-3'>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label text-end require">Tagged User</label>
                    <div className="col-sm-8">
                        <TapSelect
                            options={formData.data}
                            changeEvent={selectedOption => {
                                setSubmittedReportFilterForm(d => ({
                                    ...d,
                                    search_user: selectedOption ? selectedOption : null
                                }));
                            }}
                            required={true}
                            isSearchable={true}
                            isClearable={true}
                            value={submittedReportFilterForm.search_user}
                            placeholder="Select User"
                        />
                    </div>
                </div>
                 <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end ">Ticket Type</label>
                    <div className="col-sm-8">
                       <TapSelect
                            options={formData.allTicketType}
                             changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_ticket_type_ids: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}  
                            isMulti={true}
                            value={formData.allTicketType.filter(s => submittedReportFilterForm.search_ticket_type_ids.includes(s.value))}
                            placeholder="Select Ticket Type"
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Site</label>
                    <div className="col-sm-8" >
                        <TapSelect
                            options={iam_group_sites}
                            changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_site_ids: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={iam_group_sites.filter(s => submittedReportFilterForm.search_site_ids.includes(s.value))}
                            placeholder="Select Site"
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end">Status</label>
                    <div className="col-sm-8">
                        <TapSelect
                            options={formData.allStatusList}
                            changeEvent={o => setSubmittedReportFilterForm(d => ({ ...d, search_status: o.map(e => e.value) }))}
                            isSearchable={true}
                            isClearable={true}
                            isMulti={true}
                            value={formData.allStatusList.filter((s) =>
                                submittedReportFilterForm.search_status.includes(s.value)
                            )}
                            placeholder="Select Asset Status"
                        />
                    </div>
                </div>
                <div className="row my-3 align-items-center">
                    <label className="col-sm-3 col-form-label col-form-label-sm text-end require">Transaction Period</label>
                    <div className="col-sm-8" >
                        <PeriodSelectionWithCustom
                            periods={all_periods || []}
                            value={submittedReportFilterForm.date_range}
                            startDate={submittedReportFilterForm.date_range_start}
                            endDate={submittedReportFilterForm.date_range_end}
                            menuPlacement={bottom}
                            required={true}
                            onSelectPeriod={(period, startDate, endDate) => {
                                setSubmittedReportFilterForm(prev => ({
                                    ...prev,
                                    date_range: period,
                                    date_range_start: startDate || null,
                                    date_range_end: endDate || null
                                }));
                            }}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="pb-3 col-9 text-end">
                        <button type="submit" disabled={loading} className="btn btn-primary px-4">Show Report</button>
                    </div>
                </div>
            </form>
        );
    }

    const reportContentJsx = () => {
        
        const period = listingData.period || {};
        const reportData = listingData.data || [];
        const levels = listingData.levels || [];

        const trackingTypes = [
            {
                key: 'scs',
                label: 'SCS Tracking',
                levelKey: 'scs',
                totalKey: 'total_scs_execution',
                totalLabel: 'Total SCS Executed'
            },
            {
                key: 'iam_compliance',
                label: 'Compliance Tracking',
                levelKey: 'iam_compliance',
                totalKey: 'total_compliance_updated',
                totalLabel: 'Total Compliance Updated'
            },
            {
                key: 'ticket',
                label: 'Ticket Tracking',
                levelKey: 'ticket',
                totalKey: 'total_resolve_ticket',
                totalLabel: 'Total Resolved Tickets'
            },
            {
                key: 'compliance_no_doc',
                label: 'Compliance Documents',
                levelKey: 'compliance_no_doc',
                totalKey: 'total_compliance_doc',
                totalLabel: 'Total Compliance Documents'
            }
        ];

        return (
            <div className="bg-white pb-4">
                {loading ? <Loader /> :
                    listingData && listingData.data && listingData.data.length > 0 ?
                        <>
                            <table className="table table-hover table-borderless mx-2 mb-4">
                                <tbody>
                                    <tr>
                                        <td className="details-label" style={{ "width": "30%" }}>Period</td>
                                        <td className="details-name" style={{ "width": "66%" }}>
                                            {period.display_with_date || period.display || "-"}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="details-label">Name of the stakeholder</td>
                                        <td className="details-name">{userData.user_name || "-"}</td>
                                    </tr>
                                    <tr>
                                        <td className="details-label">Role / Level</td>
                                        <td className="details-name">{userData.level_name || "-"}</td>
                                    </tr>
                                    <tr>
                                        <td className="details-label">Sites</td>
                                        <td className="details-name">
                                            {userData.sites && userData.sites.length > 0 ? (
                                                <>
                                                    {userData.sites.slice(0, 3).map(site => site.site_name).join(', ')}
                                                    {userData.sites.length > 3 && `, + ${userData.sites.length - 3} more`}
                                                </>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="mx-2">
                                {trackingTypes.map((trackingType) => {
                                    const calculateTotalPending = (dayData) => {
                                        let total = 0;
                                        dayData.levels.forEach(level => {
                                            total += level[trackingType.levelKey] || 0;
                                        });
                                        return total;
                                    };

                                    const calculateDividedTotal = (dayData) => {
                                        if (trackingType.levelKey === 'compliance_no_doc' && levels.length > 0) {
                                            const total = calculateTotalPending(dayData);
                                            return (total / levels.length).toFixed(2);
                                        }
                                        return calculateTotalPending(dayData);
                                    };

                                    return (
                                        <div key={trackingType.key} className="mb-4">
                                            <div className="tab_content_wrapper mt-2">
                                                <span className="content_heading">{trackingType.label}</span>
                                            </div>

                                            <div className="table-container mt-3" style={{
                                                maxHeight: '400px',
                                                overflow: 'auto'
                                            }}>
                                                <table className="table table-hover table-bordered mb-0">
                                                    <thead className="text-center table-secondary">
                                                        <tr>
                                                            <th style={{ width: '13%', minWidth: '120px' }}>
                                                                Date
                                                            </th>
                                                            {levels.map(level => (
                                                                <th key={level.id} style={{
                                                                    width: levels.length === 1 ? '15%' : `calc(55% / ${levels.length})`,
                                                                    minWidth: levels.length === 1 ? '150px' : '150px'
                                                                }}>
                                                                    {level.name}
                                                                </th>
                                                            ))}
                                                            <th style={{ width: '13%', minWidth: '120px' }}>Total Pending</th>

                                                            <th style={{ width: '13%', minWidth: '120px' }}>
                                                                {trackingType.totalLabel}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {reportData.map((dayData, index) => {
                                                            const totalPending = calculateTotalPending(dayData);
                                                            const dividedTotal = calculateDividedTotal(dayData);

                                                            return (
                                                                <tr key={index}>
                                                                    <td className="text-center">{DateService.dateFormat(dayData.date)}</td>

                                                                    {levels.map(level => {
                                                                        const levelData = dayData.levels.find(l =>
                                                                            (l.level_id || l.id) === (level.level_id || level.id)
                                                                        );
                                                                        return (
                                                                            <td key={level.id} className="text-center">
                                                                                {levelData ? levelData[trackingType.levelKey] || 0 : 0}
                                                                            </td>
                                                                        );
                                                                    })}

                                                                    <td className="text-center">
                                                                        {trackingType.levelKey === 'compliance_no_doc' ? dividedTotal : totalPending}
                                                                    </td>


                                                                    <td className="text-center">
                                                                        {dayData[trackingType.totalKey] || 0}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                        : <div className="bg-white pb-4">
                            <div className="text-center py-5">
                                <p>No data available for the selected criteria</p>
                            </div>
                        </div>}
            </div>
        );
    };
    const shareTicketModalJsx = () => {
        const selectedUserEmail = formData.data.find(
            user => user.value === submittedReportFilterForm.search_user?.value
        )?.email || '';
        const filteredCcOptions = ccOptions.filter(
            ccOpt =>
                !shareEmailForm.to_emails?.some(
                    to => to.value === ccOpt.value
                )
        );

        return (
            <div className="modal fade" id={modalId}
                ref={modalElementRef} tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="addAssetModalLabel">Share Trending Escalation Report</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleClose}></button>
                        </div>

                        <form onSubmit={submitShareDocument} className="mx-2" id={modalId + "filter"}>
                            <div className="modal-body">
                                <div className="row align-items-center mb-3">
                                    <div className="col-sm-3">
                                        <label className="form-label">Tagged User</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <input type="text" disabled className="form-control" value={userData.user_name} />
                                    </div>
                                </div>
                                {submittedReportFilterForm.search_site_ids && submittedReportFilterForm.search_site_ids.length > 0 && userData.sites && userData.sites.length > 0 &&
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Sites</label>
                                        </div>
                                        <div className="col-sm-9">
                                            {userData.sites.slice(0, 3).map(site => site.site_name).join(', ')}
                                            {userData.sites.length > 3 && `, + ${userData.sites.length - 3} more`}
                                        </div>
                                    </div>}
                                     {submittedReportFilterForm.search_ticket_type_ids && submittedReportFilterForm.search_ticket_type_ids.length > 0 && (
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Ticket Type</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                    formData.allTicketType
                                                        .slice(0, 4)
                                                        .map(t => t.label)
                                                        .join(', ') +
                                                    (formData.allTicketType.length > 4
                                                        ? `, + ${formData.allTicketType.length - 4} more`
                                                        : "")
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                {submittedReportFilterForm.search_status?.length > 0 && (
                                    <div className="row align-items-center my-3">
                                        <div className="col-sm-3">
                                            <label className="form-label">Asset Status</label>
                                        </div>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                    formData.allStatusList
                                                        .filter(s => submittedReportFilterForm.search_status.includes(s.value))
                                                        .map(s => s.label)
                                                        .join(', ') || "-"
                                                }
                                            />
                                        </div>
                                    </div>
                                )}
                                <div className="row align-items-center">
                                    <div className="col-md-3">
                                        <label className="form-label require">To (Email)</label>
                                    </div>
                                    <div className="col-md-9">
                                        <TapSelect
                                            options={toOptions}
                                            changeEvent={(selectedOption) => {
                                                setShareEmailForm(prev => {
                                                    const toEmails = selectedOption ? [selectedOption] : [];
                                                    return {
                                                        ...prev,
                                                        to_emails: toEmails,
                                                        cc_emails: prev.cc_emails?.filter(
                                                            cc => !toEmails.some(to => to.value === cc.value)
                                                        )
                                                    };
                                                });
                                            }}
                                            isDisabled={true}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={toOptions.filter(option =>
                                                shareEmailForm.to_emails?.some(
                                                    email => email.value === option.value
                                                )
                                            )}
                                            placeholder="Select User"
                                        />

                                    </div>
                                </div>
                                <div className="row align-items-center mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label ">CC (Email)</label>
                                    </div>
                                    <div className="col-md-9">
                                        <TapSelect
                                            options={filteredCcOptions}
                                            changeEvent={(selectedOption) => {
                                                setShareEmailForm(prev => ({
                                                    ...prev,
                                                    cc_emails: selectedOption || []
                                                }));
                                            }}
                                            value={filteredCcOptions.filter(option =>
                                                shareEmailForm.cc_emails?.some(email => email.value === option.value)
                                            )}
                                            isSearchable={true}
                                            isMulti={true}
                                            isClearable={true}
                                            placeholder="Select or enter CC email addresses"
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label require">Subject</label>
                                    </div>

                                    <div className="col-md-9">
                                        <input
                                            name="subject"
                                            value={shareEmailForm.subject}
                                            className="form-control text-capitalize"
                                            autoComplete="off"
                                            required
                                            onChange={(e) => formInputHandler(e, 'shareEmailForm')}
                                            placeholder="Enter Subject"
                                        />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-3">
                                        <label className="form-label require">Message</label>
                                    </div>
                                    <div className="col-md-12">
                                        <CKEditor
                                            required
                                            data={shareEmailForm.message}
                                            editor={ClassicEditor}
                                            onChange={(event, editor) => {
                                                setShareEmailForm({
                                                    ...shareEmailForm,
                                                    message: editor.getData()
                                                })
                                            }}
                                            config={{
                                                placeholder: 'Please Enter Text',
                                                height: '300px',
                                                toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList']
                                            }}
                                        />
                                    </div>
                                </div></div>
                            <div className="modal-footer d-flex justify-content-end">
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-secondary me-2"
                                        data-bs-dismiss="modal"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        form={modalId + "filter"}
                                        className="btn btn-primary"
                                        disabled={saveFormSubmitting}
                                    >
                                        Submit {saveFormSubmitting && (
                                            <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />
                                        )}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <ApplicationLayout>
            <Helmet><title>Trending Escalation Report</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-sm-12 pb-3">
                        <div className={["bg-white", submittedReportFilterForm.show ? 'tbShow' : 'tbHide'].join(" ")}>
                            {formData.loading ? <Loader /> : reportFilterFormJsx()}
                        </div>
                        {reportSubmitted && (
                            <>
                                {formSearchedElems.length > 0 && (
                                    <div ref={criteriaRef}
                                        style={{
                                            position: 'sticky',
                                            top: 0,
                                            background: 'white',
                                        }}>
                                        <DisplaySearchCriteria searchedElems={formSearchedElems} />
                                    </div>
                                )}
                                {reportContentJsx()}
                            </>
                        )}
                    </div>
                </div>
            </div>
            {shareTicketModalJsx()}
        </ApplicationLayout>
    );
};

export default EscalationDataTrendingReport;